import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom"; // Import useNavigate
import { motion } from "framer-motion";
import { AiOutlineLogout, AiOutlineHighlight } from "react-icons/ai";
// import { logout } from '../../../Services/authService';
import { removeauthToken, removeToken } from "../../../utils/tokenUtils";
import { FiRefreshCcw } from "react-icons/fi";
import Cookies from "js-cookie";
import { logoutService } from "../../../services/authService";
import "./Header.css";
import { ChevronDown, ShieldCheckIcon, ShieldEllipsisIcon } from "lucide-react";
import ViewAdminProfile from "../../Components/ViewsModals/AdminProfile";
import ConfirmModal from "../../../components/Billing/ConfirmModal";
const Header = ({ user }) => {
  const navigate = useNavigate(); // Hook for programmatic navigation

  const [profileClicked, setProfileClicked] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleLogout = async () => {
    try {
      setLoading(true);

      const response = await logoutService();
      if (response.status === "success") {
        setShowConfirmModal(false);
        removeauthToken();
        navigate("/");
      } else {
        setShowConfirmModal(false);
      }

      removeauthToken();
      navigate("/");
    } catch (error) {
      console.log(error);
      setShowConfirmModal(false);
    } finally {
      setLoading(false);
      setShowConfirmModal(false);
    }
  };

  return (
    <motion.nav
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ type: "spring", stiffness: 120, damping: 20 }}
      className="fixed top-0 shadow-sm shadow-black/20 left-0 w-full  z-40"
    >
      <div className="relative group">
        {/* Glow Effect Background */}
        <div className="absolute -inset-0.5 bg-gradient-to-r from-cyan-500 to-blue-600  blur opacity-20 group-hover:opacity-40 transition duration-1000"></div>

        <div
          className="relative flex items-center justify-between h-16 px-6 
                        bg-gray-100/80 backdrop-blur-xl 
                        border border-white/10 
                        shadow-2xl shadow-blue-500/10 text-black"
        >
          {/* LEFT SECTION: Branding */}
          <Link
            to={"/admin-dashboard"}
            className="flex cursor-pointer items-center gap-3"
          >
            {/* <div className="p-2 bg-gradient-to-br from-cyan-500 to-blue-600 rounded-xl shadow-lg shadow-blue-500/20">
              <ShieldCheckIcon className="text-white text-xl" />
            </div>
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-slate-800 to-slate-400 font-bold text-xl tracking-tight">
              IDSpay<span className="text-cyan-400">Admin</span>
            </span> */}
            <img
              className="w-[150px] h-auto"
              src="/NEW IDSPAY logo.png"
              alt="logo"
            />
          </Link>

          {/* RIGHT SECTION: Actions */}
          <div className="flex items-center gap-2 md:gap-6">
            {/* PROFILE SECTION */}
            <div
              onClick={() => setProfileClicked(!profileClicked)}
              className="flex items-center gap-3 px-3 py-1.5 rounded-xl 
bg-[#0A1F44] backdrop-blur-md border border-white/10 
hover:bg-blue-600 transition-all duration-300 cursor-pointer group"
            >
              {/* Avatar */}
              <div className="relative">
                <img
                  src={`https://ui-avatars.com/api/?name=${user?.name || "User"}&background=0DA2D9&color=fff`}
                  alt="User"
                  className="h-9 w-9 rounded-full ring-2 ring-white/20 group-hover:ring-indigo-400 transition-all"
                />

                {/* Online status */}
                <span
                  className="absolute bottom-0 right-0 h-2.5 w-2.5 
    bg-emerald-400 border-2 border-slate-900 rounded-full"
                ></span>
              </div>

              {/* User Info */}
              <div className="hidden lg:flex flex-col leading-tight">
                <span className="text-sm font-semibold text-gray-100 tracking-wide">
                  {user?.name || "User"}
                </span>

                <span className="text-[11px] font-medium text-gray-50 uppercase tracking-wider">
                  {user?.role || "Admin"}
                </span>
              </div>
            </div>

            {/* Vertical Divider */}
            <div className="hidden md:block h-6 w-[1px] bg-slate-700/50"></div>

            {/* LOGOUT BUTTON */}
            <motion.button
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              onClick={() => setShowConfirmModal(true)}
              className="p-2.5 md:px-4 md:py-2 rounded-xl
                         bg-gradient-to-br from-cyan-500 to-blue-600 text-white
                         hover:from-red-500 hover:to-red-700 hover:text-white transition-all duration-200
                         flex items-center gap-2"
            >
              <AiOutlineLogout className="text-lg" />
              <span className="hidden md:block font-bold text-sm">Logout</span>
            </motion.button>
          </div>
        </div>
      </div>

      <ViewAdminProfile
        isOpen={profileClicked}
        onClose={() => setProfileClicked(!profileClicked)}
        profileData={user}
      />

      <ConfirmModal
      title="Do You Want To Logout?"
      cancelText="No, I will stay here"
      confirmText="Proceed To Logout"
        isOpen={showConfirmModal}
        onCancel={() => setShowConfirmModal(false)}
        onConfirm={handleLogout}
        loading={loading}
      />
    </motion.nav>
  );
};

export default Header;
